export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var to_load_json_atlas = {
	reels_atlas: [
		imgsPath + "reels/reels_atlas_{q}.png",
		imgsPath + "reels/reels_atlas_{q}.json",
	],
	symbols_atlas: [
		imgsPath + "symbols/symbols_atlas_{q}.png",
		imgsPath + "symbols/symbols_atlas_{q}.json",
	],
	symbols_blur_atlas: [
		imgsPath + "symbols/symbols_blur_atlas_{q}.png",
		imgsPath + "symbols/symbols_blur_atlas_{q}.json",
	],

	flame_atlas: [
		imgsPath + "symbols/symbol_Candle/flame_atlas_{q}.png",
		imgsPath + "symbols/symbol_Candle/flame_atlas_{q}.json",
	],
	fs_buttons: [
		imgsPath + "freespins/fs_buttons_atlas_{q}.png",
		imgsPath + "freespins/fs_buttons_atlas_{q}.json",
	],

	symbol_Candle_atlas: [
		imgsPath + "symbols/symbol_Candle/symbol_Candle_atlas_{q}.png",
		imgsPath + "symbols/symbol_Candle/symbol_Candle_atlas_{q}.json",
	],
	symbol_Pestle_atlas: [
		imgsPath + "symbols/symbol_Pestle/symbol_Pestle_atlas_{q}.png",
		imgsPath + "symbols/symbol_Pestle/symbol_Pestle_atlas_{q}.json",
	],
	symbol_J_atlas: [
		imgsPath + "symbols/symbol_J/symbol_J_atlas_{q}.png",
		imgsPath + "symbols/symbol_J/symbol_J_atlas_{q}.json",
	],
	symbol_K_atlas: [
		imgsPath + "symbols/symbol_K/symbol_K_atlas_{q}.png",
		imgsPath + "symbols/symbol_K/symbol_K_atlas_{q}.json",
	],
	symbol_Q_atlas: [
		imgsPath + "symbols/symbol_Q/symbol_Q_atlas_{q}.png",
		imgsPath + "symbols/symbol_Q/symbol_Q_atlas_{q}.json",
	],
	symbol_A_atlas: [
		imgsPath + "symbols/symbol_A/symbol_A_atlas_{q}.png",
		imgsPath + "symbols/symbol_A/symbol_A_atlas_{q}.json",
	],
	symbol_Gold_atlas: [
		imgsPath + "symbols/symbol_Gold/symbol_Gold_atlas_{q}.png",
		imgsPath + "symbols/symbol_Gold/symbol_Gold_atlas_{q}.json",
	],
	symbol_Ring_atlas: [
		imgsPath + "symbols/symbol_Ring/symbol_Ring_atlas_{q}.png",
		imgsPath + "symbols/symbol_Ring/symbol_Ring_atlas_{q}.json",
	],
	symbol_Crystal_red_atlas: [
		imgsPath + "symbols/symbol_Crystal_red/symbol_Crystal_red_atlas_{q}.png",
		imgsPath + "symbols/symbol_Crystal_red/symbol_Crystal_red_atlas_{q}.json",
	],
	symbol_Crystal_blue_atlas: [
		imgsPath + "symbols/symbol_Crystal_blue/symbol_Crystal_blue_atlas_{q}.png",
		imgsPath + "symbols/symbol_Crystal_blue/symbol_Crystal_blue_atlas_{q}.json",
	],

	symbol_Book_shine_atlas: [
		imgsPath + "symbols/symbol_Book/symbol_Book_shine_atlas_{q}.png",
		imgsPath + "symbols/symbol_Book/symbol_Book_shine_atlas_{q}.json",
	],
	symbol_Book_atlas: [
		imgsPath + "symbols/symbol_Book/symbol_Book_atlas_{q}.png",
		imgsPath + "symbols/symbol_Book/symbol_Book_atlas_{q}.json",
	],
	symbol_Book_fs_atlas: [
		imgsPath + "symbols/symbol_Book/symbol_Book_fs_atlas_{q}.png",
		imgsPath + "symbols/symbol_Book/symbol_Book_fs_atlas_{q}.json",
	],

	random_appear_atlas: [
		imgsPath + "symbols/wild/wild_random_appear_atlas_{q}.png",
		imgsPath + "symbols/wild/wild_random_appear_atlas_{q}.json",
	],
	random_appear_shine_atlas: [
		imgsPath + "symbols/wild/wild_random_appear_shine_atlas_{q}.png",
		imgsPath + "symbols/wild/wild_random_appear_shine_atlas_{q}.json",
	],

	symbol_Alchemist_shine_atlas: [
		imgsPath + "symbols/symbol_Alchemist/symbol_Alchemist_shine_atlas_{q}.png",
		imgsPath + "symbols/symbol_Alchemist/symbol_Alchemist_shine_atlas_{q}.json",
	],
	symbol_Alchemist_shine_static_atlas: [
		imgsPath +
			"symbols/symbol_Alchemist/symbol_Alchemist_shine_static_atlas_{q}.png",
		imgsPath +
			"symbols/symbol_Alchemist/symbol_Alchemist_shine_static_atlas_{q}.json",
	],
	symbol_Alchemist_cast_atlas: [
		imgsPath + "symbols/symbol_Alchemist/symbol_Alchemist_cast_atlas_{q}.png",
		imgsPath + "symbols/symbol_Alchemist/symbol_Alchemist_cast_atlas_{q}.json",
	],
	cast_shine_atlas: [
		imgsPath + "symbols/symbol_Alchemist/cast_shine_atlas_{q}.png",
		imgsPath + "symbols/symbol_Alchemist/cast_shine_atlas_{q}.json",
	],

	/**/ freespins_shine_atlas: [
		imgsPath + "freespins/freespins_shine_atlas_{q}.png",
		imgsPath + "freespins/freespins_shine_atlas_{q}.json",
	],
	searching_atlas: [
		imgsPath + "freespins/searching_atlas_{q}.png",
		imgsPath + "freespins/searching_atlas_{q}.json",
	],

	papers_atlas: [
		imgsPath + "freespins/papers_atlas_{q}.png",
		imgsPath + "freespins/papers_atlas_{q}.json",
	],

	//"shuffle_atlas": [imgsPath + "shuffle/shuffle_atlas_{q}.png", imgsPath + "shuffle/shuffle_atlas_{q}.json"],
	mill_atlas: [
		imgsPath + "shuffle/mill_atlas_{q}.png",
		imgsPath + "shuffle/mill_atlas_{q}.json",
	],
	blade_atlas: [
		imgsPath + "shuffle/blade_atlas_{q}.png",
		imgsPath + "shuffle/blade_atlas_{q}.json",
	],
	blade_blur_atlas: [
		imgsPath + "shuffle/blade_blur_atlas_{q}.png",
		imgsPath + "shuffle/blade_blur_atlas_{q}.json",
	],

	dust_atlas: [
		imgsPath + "dust_atlas_{q}.png",
		imgsPath + "dust_atlas_{q}.json",
	],
	multi_big_atlas: [
		imgsPath + "reels/multi_big_atlas_{q}.png",
		imgsPath + "reels/multi_big_atlas_{q}.json",
	],
	multi_small_atlas: [
		imgsPath + "reels/multi_small_atlas_{q}.png",
		imgsPath + "reels/multi_small_atlas_{q}.json",
	],

	preinfo_atlas: [
		imgsPath + "preinfo/preinfo_atlas_{q}.png",
		imgsPath + "preinfo/preinfo_atlas_{q}.json",
	],

	bigwin_shine_atlas: [
		imgsPath + "bigwin/bigwin_shine_atlas_{q}.png",
		imgsPath + "bigwin/bigwin_shine_atlas_{q}.json",
	],

	shuffling_shine_atlas: [
		imgsPath + "symbols/symbol_Alchemist/shuffling_shine_atlas_{q}.png",
		imgsPath + "symbols/symbol_Alchemist/shuffling_shine_atlas_{q}.json",
	],
	alchemist_shuffling_atlas: [
		imgsPath + "symbols/symbol_Alchemist/shuffling_atlas_{q}.png",
		imgsPath + "symbols/symbol_Alchemist/shuffling_atlas_{q}.json",
	],
	alchemist_changing_atlas: [
		imgsPath + "symbols/symbol_Alchemist/changing_atlas_{q}.png",
		imgsPath + "symbols/symbol_Alchemist/changing_atlas_{q}.json",
	],
};

export const to_load = {
	// 'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
	win_font_bg: imgsPath + "fonts/win_font_bg_{q}.png",

	reels_background: imgsPath + "reels/reels_background_{q}.jpg",
	reels_cover_left: imgsPath + "reels/reels_cover_left_{q}.png",
	reels_cover_low: imgsPath + "reels/reels_cover_low_{q}.png",

	preinfo_bg: imgsPath + "preinfo/preinfo_bg_{q}.png",

	freespins_shine_back: imgsPath + "freespins/freespins_shine_back_{q}.png",

	wintable_1: imgsPath + "wintable/wintable_1_{q}.jpg",
	wintable_2: imgsPath + "wintable/wintable_2_{q}.png",
	//"wintable_3": imgsPath + "wintable/wintable_3_{q}.jpg",
	wintable_4: imgsPath + "info/info_{q}.jpg",

	bigwin_sign: imgsPath + "bigwin/bigwin_sign_{q}.png",
	freespins_sign: imgsPath + "freespins/freespins_sign_{q}.png",

	changing_particle_blue: imgsPath + "symbols/changing_particle_blue_{q}.png",
	changing_particle_green: imgsPath + "symbols/changing_particle_green_{q}.png",
	changing_particle_pink: imgsPath + "symbols/changing_particle_pink_{q}.png",
	changing_particle_red: imgsPath + "symbols/changing_particle_red_{q}.png",

	multiplier_shine: imgsPath + "reels/multiplier_shine_{q}.png",
	multiplier_reel: imgsPath + "reels/reel_small_{q}.png",

	freespins_info: imgsPath + "freespins/freeSpins_background_{q}.png",
	info_winlines: imgsPath + "info/winningLines_{q}.png",
	paper_random_back: imgsPath + "freespins/paper_random_back_{q}.png",
};

var audioType = "ogg";

export const to_load_audio = {
	bonus_FreeSpins_Counter: audioPath + "bonus_FreeSpins_Counter." + audioType,

	reel_Spin: audioPath + "reel_Spin." + audioType,
	reel_Stop: audioPath + "reel_Stop." + audioType,

	//"bg_Layer_1": audioPath + "bg_Layer_1." + audioType,
	//"bg_Layer_2": audioPath + "bg_Layer_2." + audioType,
	bg_Music: audioPath + "bg_Music." + audioType,

	bg_FreeSpins_Start: audioPath + "bg_FreeSpins_Start." + audioType,
	bg_FreeSpins_Loop: audioPath + "bg_FreeSpins_Loop." + audioType,

	bonus_Scatter_1: audioPath + "bonus_Scatter_1." + audioType,
	bonus_Scatter_2: audioPath + "bonus_Scatter_2." + audioType,
	bonus_Scatter_3: audioPath + "bonus_Scatter_3." + audioType,

	bonus_Wild_Changing_1: audioPath + "bonus_Wild_Changing_1." + audioType,
	bonus_Wild_Changing_2: audioPath + "bonus_Wild_Changing_2." + audioType,
	bonus_Wild_Changing_4: audioPath + "bonus_Wild_Changing_4." + audioType,

	bonus_Wild_Shuffle: audioPath + "bonus_Wild_Shuffle." + audioType,
	bonus_Wild_Random: audioPath + "bonus_Wild_Random." + audioType,
	symbol_Wild_Start: audioPath + "symbol_Wild_Start." + audioType,

	win_Expand_1: audioPath + "win_Expand_1." + audioType,
	win_Expand_2: audioPath + "win_Expand_2." + audioType,
	win_Expand_3: audioPath + "win_Expand_3." + audioType,

	bonus_Paper_1: audioPath + "bonus_Paper_1." + audioType,
	bonus_Paper_2: audioPath + "bonus_Paper_2." + audioType,
	bonus_Paper_3: audioPath + "bonus_Paper_3." + audioType,
	bonus_Scatter_Pick: audioPath + "bonus_Scatter_Pick." + audioType,
	bg_Scatter_Idle: audioPath + "bg_Scatter_Idle." + audioType,
	bonus_Wild_Expand_Online: audioPath + "bonus_Wild_Expand_Online." + audioType,

	bwin_BigWin: audioPath + "bwin_BigWin." + audioType,
	bwin_BigWin_End: audioPath + "bwin_BigWin_End." + audioType,
	bwin_FreeSpins: audioPath + "bwin_FreeSpins." + audioType,
	win_Multiplier: audioPath + "win_Multiplier." + audioType,
	//"ui_Counter": audioPath + "ui_Counter." + audioType,
	//"ui_Counter_Stop": audioPath + "ui_Counter_Stop." + audioType,

	win_Ring_5x: audioPath + "win_Ring_5x." + audioType,
	win_Ring_4x: audioPath + "win_Ring_4x." + audioType,
	win_Ring_3x: audioPath + "win_Ring_3x." + audioType,
	win_Ring_2x: audioPath + "win_Ring_2x." + audioType,
	win_RedCrystal_5x: audioPath + "win_RedCrystal_5x." + audioType,
	win_RedCrystal_4x: audioPath + "win_RedCrystal_4x." + audioType,
	win_RedCrystal_3x: audioPath + "win_RedCrystal_3x." + audioType,
	win_RedCrystal_2x: audioPath + "win_RedCrystal_2x." + audioType,
	win_BlueCrystal_5x: audioPath + "win_BlueCrystal_5x." + audioType,
	win_BlueCrystal_4x: audioPath + "win_BlueCrystal_4x." + audioType,
	win_BlueCrystal_3x: audioPath + "win_BlueCrystal_3x." + audioType,
	win_BlueCrystal_2x: audioPath + "win_BlueCrystal_2x." + audioType,
	win_Pestle_5x: audioPath + "win_Pestle_5x." + audioType,
	win_Pestle_4x: audioPath + "win_Pestle_4x." + audioType,
	win_Pestle_3x: audioPath + "win_Pestle_3x." + audioType,
	win_FlaskMid_5x: audioPath + "win_FlaskMid_5x." + audioType,
	win_FlaskMid_4x: audioPath + "win_FlaskMid_4x." + audioType,
	win_FlaskMid_3x: audioPath + "win_FlaskMid_3x." + audioType,
	win_FlaskLow_5x: audioPath + "win_FlaskLow_5x." + audioType,
	win_FlaskLow_4x: audioPath + "win_FlaskLow_4x." + audioType,
	win_FlaskLow_3x: audioPath + "win_FlaskLow_3x." + audioType,
	win_FlaskHigh_5x: audioPath + "win_FlaskHigh_5x." + audioType,
	win_FlaskHigh_4x: audioPath + "win_FlaskHigh_4x." + audioType,
	win_FlaskHigh_3x: audioPath + "win_FlaskHigh_3x." + audioType,
	win_Coin_5x: audioPath + "win_Coin_5x." + audioType,
	win_Coin_4x: audioPath + "win_Coin_4x." + audioType,
	win_Coin_3x: audioPath + "win_Coin_3x." + audioType,
	win_Coin_2x: audioPath + "win_Coin_2x." + audioType,
	win_Candle_5x: audioPath + "win_Candle_5x." + audioType,
	win_Candle_4x: audioPath + "win_Candle_4x." + audioType,
	win_Candle_3x: audioPath + "win_Candle_3x." + audioType,

	symbol_Wild: audioPath + "symbol_Wild." + audioType,
	symbol_Scatter_1: audioPath + "symbol_Scatter_1." + audioType,
	symbol_Scatter_2: audioPath + "symbol_Scatter_2." + audioType,
	symbol_Scatter_3: audioPath + "symbol_Scatter_3." + audioType,
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",	};

(function () {
	for (var i = 1; i <= 15; i++) {
		to_load_audio["bonus_Wild_Changing_3_" + i] =
			audioPath + "bonus_Wild_Changing_3_" + i + "." + audioType;
	}
})();

export const to_load_json = {
	infotext: assetsPath + "info/info_{l}.json",
};

export const to_load_fonts = {
	/*'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },*/

	font_normal_win: {
		img: imgsPath + "fonts/win_count_export.png",
		xml: imgsPath + "fonts/win_count_export.xml",
	},
	font_big_win: {
		img: imgsPath + "fonts/big_win_export.png",
		xml: imgsPath + "fonts/big_win_export.xml",
	},
	font_wintable: {
		img: imgsPath + "fonts/font_wintable_export.png",
		xml: imgsPath + "fonts/font_wintable_export.xml",
	},
};

// var to_load_spritesheets = {
//     //"wild_random_shine_sheet": { "url": imgsPath + "symbols/wild/wild_random_appear_shine_sheet_{q}.png", "w": 207, "h": 207 }
// };

export function set_sounds(server_config) {}
